import React, { useEffect, useState } from "react";
import {
  AppBar,
  Button,
  Card,
  CardContent,
  IconButton,
  TextField,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { Help } from "@material-ui/icons";
import Alert from "@material-ui/lab/Alert";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import CompanyDataService from "../../services/CompanyService";
import { Tooltip } from "@mui/material";

const DarkTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "black !important",
    fontSize: "15px !important",
    padding: theme.spacing(1.5),
  },
  arrow: {
    color: "black",
  },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(0.5),
    minWidth: 120,
  },
  root: {
    flexGrow: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      // width: "31.2ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
  },
  item: {
    minHeight: "auto",
    alignItems: "center",
  },
  titleContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  helpIcon: {
    padding: 4,
    color: "inherit",
  },
}));

function CompanyForm() {
  const classes = useStyles();
  const [message, setMessage] = useState("");
  const [company, setCompany] = useState({
    id: 1,
    name: "",
    address: "",
    phone: "",
    owner: "",
    city: "",
  });
  const [exists, setExists] = useState(false);

  useEffect(() => {
    checkAndRetrieveCompany();
  }, []);

  const checkAndRetrieveCompany = () => {
    CompanyDataService.get(1)
      .then((response) => {
        if (response.data) {
          setCompany({ ...response.data, id: 1 });
          setExists(true);
        } else {
          setExists(false);
        }
      })
      .catch(() => {
        setExists(false);
      });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCompany({ ...company, [name]: value });
  };

  const saveCompany = () => {
    if (exists) {
      updateCompany();
    } else {
      createCompany();
    }
  };

  const createCompany = () => {
    CompanyDataService.create(company)
      .then(() => {
        showSuccess("Успешно запазихте данните!");
        checkAndRetrieveCompany();
      })
      .catch(() => {
        showError("Грешка при запазване на данни!");
      });
  };

  const updateCompany = () => {
    CompanyDataService.update(1, company)
      .then(() => {
        showSuccess("Успешно обновихте данните!");
        checkAndRetrieveCompany();
      })
      .catch(() => {
        showError("Грешка при обновяване на данните!");
      });
  };

  const showSuccess = (msg) => {
    setMessage(<Alert severity="success">{msg}</Alert>);
    setTimeout(() => setMessage(""), 5000);
  };

  const showError = (msg) => {
    setMessage(<Alert severity="error">{msg}</Alert>);
    setTimeout(() => setMessage(""), 5000);
  };

  const fields = [
    { name: "name", label: "Име на хотел" },
    { name: "address", label: "Адрес на хотел" },
    { name: "phone", label: "Служебен телефон" },
    { name: "city", label: "Град" },
  ];

  return (
    <Card className={classes.item}>
      <AppBar position="static" elevation={0} color="primary">
        <Toolbar>
          <div className={classes.titleContainer}>
            <Typography variant="subtitle1" color="inherit">
              Хотелски Данни
            </Typography>
            <DarkTooltip
              title="Тези данни ще бъдат използвани в имейлите за QR достъп"
              arrow
            >
              <IconButton className={classes.helpIcon} size="small">
                <Help fontSize="small" />
              </IconButton>
            </DarkTooltip>
          </div>
        </Toolbar>
      </AppBar>
      {message}
      <CardContent>
        <form className={classes.root}>
          {fields.map((field) => (
            <TextField
              key={field.name}
              required
              label={field.label}
              variant="outlined"
              name={field.name}
              value={company[field.name]}
              onChange={handleInputChange}
              size="small"
            />
          ))}
          <Button onClick={saveCompany} variant="contained" color="primary">
            {exists ? "Обнови" : "Създай"}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
}

export default CompanyForm;
